<template>
  <div>
    <common-table :table-columns="tableColumns" :url="url" :operate="[]" :form-fields="formFields" :permission="permission" :searchs="searchs" ref="table"/>
  </div>
</template>

<script>
import CommonTable from "../../components/CommonTable/CommonTable";
export default {
  name: "InvestmentConfig",
  components: {CommonTable},
  data() {
    return {
      rechargeVisible: false,
      rechargeForm: {
        agentId: '',
        username: '',
        amount: '',
        expound: '',
        activityName:''
      },
      domainTitle: '',
      domainVisible: false,
      domainForm: {
        agentId: '',
        domain: '',
        activityName:'',
      },
      domains: [],
      domainIds: [],
      agent: {},

      resetPwdVisible: false,
      resetPwdForm: {
        id: '',
        username: '',
        password: '',
        googleCode: ''
      },

      topAgents: null,
      agentParentForm: {
        id: '',
        parentId: '',
        username: '',
      },
      agentParentVisible: false,
      searchs:[
        {
          name: 'agentId',
          placeholder: '代理',
          type: 'select',
          selectUrl: '/agent/getAll',
          selectData: [],
        },
      ],
      permission:{
        add: 'investmentConfig:add',
        update: 'investmentConfig:update',
        delete: 'investmentConfig:delete',
        deleteBatch: 'investmentConfig:deleteBatch'
      },
      url: {
        get: '/investmentConfig/listByCondition',
        add: '/investmentConfig/add',
        update: '/investmentConfig/update',
        delete: '/investmentConfig/delete',
        delete_batch: '/investmentConfig/deleteBatch'
      },
      tableColumns: [{
        field: 'id',
        label: 'ID',
        show: true,
        width: '75',
      }, {
        field: 'agentId',
        label: '代理',
        selectUrl: '/agent/getAll',
        selectData: [],
        show: {
          type: 'select',
        },
        detail: false,
        width: '',
      }, {
        field: 'cycle',
        label: '周期',
        show: true,
      }, ],
      formFields: {
        addTitle: '添加智能投资配置',
        updateTitle: '修改智能投资配置',
        labelWidth: '90px',
        model: [{
          field: 'agentId',
          label: '代理：',
          type: 'select',
          placeholder: '请选择代理',
          rules:[{required: true, message: '请选择代理', trigger: 'blur'}],
          selectUrl: '/agent/getAll',
          selectData: [],
          add: true,
          update: true,
          filterable: true,
        }, {
          field: 'cycle',
          label: '周期：',
          type: 'input',
          placeholder: '周期',
          rules:[{
            message: '请输入周期', trigger: 'blur', required: true
          }],
          add: true,
          update: true
        }]
      }
    }
  },
}
</script>

<style scoped>

</style>
